// Personal notes — free-form Markdown notes in the user's Workspace.
//
// Owner-scoped `notes` collection (user_id = creator). Phase 1 is private only;
// the sharing layer (spaces / members) is added later without disturbing these
// rows. All writes require auth and fail soft for guests / offline.
import { pb } from "./pocketbase.js";
import { isAuthed, currentUser } from "./auth.js";

export async function fetchNotes() {
  if (!isAuthed()) return [];
  const uid = currentUser()?.id;
  if (!uid) return [];
  try {
    return await pb.collection("notes").getFullList({
      filter: pb.filter("user_id = {:uid}", { uid }),
      sort: "-updated",
    });
  } catch {
    return [];
  }
}

export async function getNote(id) {
  if (!isAuthed() || !id) return null;
  try {
    return await pb.collection("notes").getOne(id);
  } catch {
    return null;
  }
}

export async function createNote({ title, body_md }) {
  if (!isAuthed()) throw new Error("Sign in to save notes.");
  const uid = currentUser().id;
  return pb.collection("notes").create({
    user_id: uid,
    title: (title || "").slice(0, 200),
    body_md: body_md || "",
  });
}

export async function updateNote(id, { title, body_md }) {
  if (!isAuthed()) throw new Error("Sign in to save notes.");
  return pb.collection("notes").update(id, {
    title: (title || "").slice(0, 200),
    body_md: body_md || "",
  });
}

export async function deleteNote(id) {
  if (!isAuthed() || !id) return;
  try {
    await pb.collection("notes").delete(id);
  } catch {
    /* best effort */
  }
}
